//import "./registerServiceWorker";
// Import Bootstrap and BootstrapVue CSS files (order is important)
import "./css/custom.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import moment from "moment";
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";

import App from "./App.vue";
import NumberFilters from "./filters/NumberFilters";
import StringFilters from "./filters/StringFilters";
import router from "./router";
import store from "./store";
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";
import "img-comparison-slider";

// PrimeVue
// Resources
// https://forum.primefaces.org/viewtopic.php?t=68417
// https://stackoverflow.com/questions/72521936/primevue-data-table-styling-not-working-in-vue3
import PrimeVue from "primevue/config";
import "primevue/resources/themes/md-light-deeppurple/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

Vue.use(PrimeVue, { unstyled: true });
Vue.config.productionTip = false;

Vue.config.ignoredElements = [/img-comparison-slider/];

Vue.use(StringFilters);
Vue.use(NumberFilters);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueReCaptcha, { siteKey: "6Ld9cBQiAAAAAJJ7pzjK2mXJ_BCCZL6gJvOHY9fO" });
Vue.use(VueEasytable);

router.beforeEach(async (to, from, next) => {
  try {
    const isAPIOnly = (store.state.Affiliate as any).isAPIOnly as boolean;
    const isSignedIn = store.state.SignedIn as any as boolean;

    if (isAPIOnly && to.name != "apionly" && to.name != "forgotpassword" && to.name != "newuserinvite" && !isSignedIn) {
      next("/apionly");
      return;
    }

    if (router.currentRoute.query.gclid) {
      localStorage.setItem("gclid", router.currentRoute.query.gclid?.toString());
    }
    if (router.currentRoute.query.fbclid) {
      localStorage.setItem("fbclid", router.currentRoute.query.fbclid?.toString());
    }
    if (router.currentRoute.query.utm_source) {
      localStorage.setItem("utm_source", router.currentRoute.query.utm_source?.toString());
    }
    if (router.currentRoute.query.utm_medium) {
      localStorage.setItem("utm_medium", router.currentRoute.query.utm_medium?.toString());
    }
    if (router.currentRoute.query.utm_campaign) {
      localStorage.setItem("utm_campaign", router.currentRoute.query.utm_campaign?.toString());
    }
    if (router.currentRoute.query.utm_term) {
      localStorage.setItem("utm_term", router.currentRoute.query.utm_term?.toString());
    }
    if (router.currentRoute.query.utm_content) {
      localStorage.setItem("utm_content", router.currentRoute.query.utm_content?.toString());
    }

    const gclid = localStorage.getItem("gclid");
    const fbclid = localStorage.getItem("fbclid");
    const utm_source = localStorage.getItem("utm_source");
    const utm_medium = localStorage.getItem("utm_medium");
    const utm_campaign = localStorage.getItem("utm_campaign");
    const utm_term = localStorage.getItem("utm_term");
    const utm_content = localStorage.getItem("utm_content");
    if (utm_source || utm_medium || utm_campaign || utm_term || utm_content || gclid || fbclid) {
      store.commit("setUTM", {
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        utm_term: utm_term,
        utm_content: utm_content,
        gclid: gclid,
        fbclid: fbclid,
      });
      if (store.state.Role == "Patient") {
        const r = await store.dispatch("UpdateUTM", {
          utm_source: utm_source,
          utm_medium: utm_medium,
          utm_campaign: utm_campaign,
          utm_term: utm_term,
          utm_content: utm_content,
          gclid: gclid,
          fbclid: fbclid,
        });
      }
    }

    const lang = router.currentRoute.query.lang?.toString().toUpperCase();
    if (lang) {
      store.commit("setLang", lang);
    }

    let newQuery = to.query;

    if (gclid && !to.query.gclid) {
      newQuery = { ...newQuery, gclid: gclid };
    }

    if (fbclid && !to.query.fbclid) {
      newQuery = { ...newQuery, fbclid: fbclid };
    }

    if (JSON.stringify(to.query) !== JSON.stringify(newQuery)) {
      next({
        path: to.path,
        query: newQuery,
        hash: to.hash,
      });
      return;
    }

    next();
  } catch (error) {
    console.error("Error in navigation guard:", error);
    next(false); // Cancel the navigation if there's an error.
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// Subscribe to store updates
store.subscribe((state) => {
  // Store the state object as a JSON string
  sessionStorage.setItem("s", JSON.stringify(store.state));
});

store.subscribeAction((action, state) => {
  if (action.type != "Refresh" && state.SignedIn && new Date() > moment(state.LastRefreshDate).add(15, "m").toDate()) {
    store.dispatch("Refresh");
  }
});
